<template>
    <div class="rightCon"  v-loading.fullscreen.lock="fullscreenLoading">
        <el-select v-model="currentTenantGuid" placeholder="请选择公司" @change="changeCompany">
            <el-option v-for="item in companyOption" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
        </el-select>
    </div>
</template>
  
<script>
const ENV = location.href.indexOf('https://scm-operation.csyaoly.com') > -1?'pro': location.href.indexOf('https://scm-operation.cs4pl.com') > -1?'pre':'sit'
import cloneDeep from 'lodash/cloneDeep';
export default {
    name: 'SwitchCompany',
    data() {
        return {
            fullscreenLoading:false,
            currentTenantGuid: '',
            companyOption: [],
            appSideGuid:  (ENV=='pre'|| ENV=='pro')? '03cb364e04d894a44cdb94273abffa13':'13312e94ceb8eb986b2885445530add0',
        };
    },
    props: {

    },
    created() {
        this.getCurrentuser();
        this.getLastLogin();
    },
    methods: {
        getCurrentuser() {
            let self = this;
            self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenants-by-currentuser`).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    if (res.data.data != null && res.data.data != '') {
                        this.companyOption = res.data.data;
                    }
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        getLastLogin() {
            let self = this;
            self.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/user/get-latest-login-info`).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.currentTenantGuid = res.data.data.latestLoginTenantGuid;
                } else {
                    self.$message.error(res.data.msg);
                }
            });

        },
        changeCompany(tenantGuid) {
            let token = localStorage.token;
            let refreshToken = localStorage.refreshToken;
            localStorage.clear();
            localStorage.guid = tenantGuid;
            localStorage.token = token;
            localStorage.refreshToken = refreshToken;
            this.fullscreenLoading = true;
            this.getAddRedis(tenantGuid);
            let listItem = this.companyOption.filter(item=>item.guid==tenantGuid);
            localStorage.supertubeFlag = listItem[0].supertubeFlag;

        },
        getCurrentstaff(tenantGuid) {
            let self = this;
            self.api
                .get(`/${serverConfig.msPersonnelService}/staff/data/get-currentstaff?` + `tenantGuid=` + tenantGuid)
                .then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        localStorage.setItem('userInfo', JSON.stringify(res.data.data));
                        this.getCodeList(tenantGuid);
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
        },
        getMenuList(tenantGuid) {
            let self = this;
            let appSideGuid = self.appSideGuid;
            self.api
                .get(
                    `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?` +
                    `appType=01&tenantGuid=` +
                    tenantGuid +
                    `&appSideIdentifier=scm_operative`,
                )
                .then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        self.menuList = res.data.data;
                        self.menuList.forEach(function (i, idx) {
                            if (i.externalLinkMark == '01') {
                                i.src = i.path;
                                i.path = '/reportQueryList-' + idx;
                                console.log('1', i.externalLinkMark);
                                if (i.children != null && i.children != '') {
                                    i.children.forEach(function (j, index) {
                                        index = index + 1;
                                        if (j.externalLinkMark == '01') {
                                            console.log('11', j.externalLinkMark);
                                            j.src = j.path;
                                            j.path = '/reportQuery-' + idx + index;
                                        }
                                    });
                                }
                            }
                        });
                        localStorage.setItem('appSideGuid', JSON.stringify(appSideGuid));
                        localStorage.setItem('allMenuList', JSON.stringify(cloneDeep(res.data.data)));
                        this.fullscreenLoading =false;
                        this.$message.success('切换成功');
                   
                        if (res.data.data[0].menuName == '主页') {
                            //新首页
                            if (res.data.data[0].path == '/SZ_homePageReportNew' && res.data.data[0].children) {
                                localStorage.setItem('reportMenuList', JSON.stringify(res.data.data[0].children));
                                window.location.href = `${location.origin}/SZ_homePageReportNew?pageMenuGuid=${res.data.data[0].guid}`
                                return;
                            }
                            //有个人首页，导航不显示个人主页菜单，直接跳转
                            self.menuList = self.menuList.slice(1);
                            localStorage.setItem('menuList', JSON.stringify(self.menuList));
                            window.location.href = `${location.origin}/SZ_homePageReportNew?pageMenuGuid=${res.data.data[0].guid}`
                        } else {
                            localStorage.setItem('menuList', JSON.stringify(self.menuList));
                            if (res.data.data[0].children != null && res.data.data[0].children.length > 0) {
                                window.location.href = `${location.origin}${res.data.data[0].children[0].path}`
                            } else {
                                window.location.href = `${location.origin}/reportQueryList-0`
                            }
                        }
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
        },
        getAddRedis(tenantGuid) {
            let self = this;
            self.api
                .get(`/${serverConfig.msPersonnelService}/staff/data/add-currentstaff-to-redis?tenantGuid=${tenantGuid}`)
                .then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        this.getCurrentstaff(tenantGuid)
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
        },
        getCodeList(tenantGuid) {
            let that = this;
            that.api.get(`/${serverConfig.msConfigureService}/dict/data/get-all`).then((resp) => {
                if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    localStorage.codeList = JSON.stringify(resp.data.data)
                    this.getMenuList(tenantGuid)
                } else {
                    that.$message.error(resp.data.msg);
                }
            });
        },
    },
};
</script>
  
<style scoped>
.rightCon {
    position: absolute;
    right: 200px;
    top: 60%;
    transform: translateY(-50%);
}

.rightCon /deep/ .el-input__inner {
    border: none;
    padding: 0;
    font-size: 16px;
    color: #4D4D4D;
    font-family: 'PingFang SC';
    padding-right: 30px;
    background: none;
    line-height: 30px;
    height: 30px;
    text-align: right;
    width: 280px;
}

.rightCon /deep/ .el-input__icon {
    line-height: 30px;
}

.rightCon /deep/ .el-select-dropdown__item.selected {
    color: #4fa1a4;
}

.rightCon /deep/ .el-select .el-input .el-select__caret {
    height: auto;
    font-size: 1.2rem;
    color: #4D4D4D;
}
</style>
  